import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-check" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "form-check-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schemesList, (scheme) => {
      return (_openBlock(), _createElementBlock("label", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "radio",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeScheme) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
          value: scheme.name
        }, null, 40, _hoisted_2), [
          [_vModelRadio, _ctx.activeScheme]
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$te(scheme.translationKey) ? _ctx.$t(scheme.translationKey) : scheme.name), 1)
      ]))
    }), 256))
  ]))
}